/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Four_Plus_OneInputs */

const cs_enum_four_plus_one = /** @type {(inputs: Enum_Four_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+1`)
};

const en_enum_four_plus_one = /** @type {(inputs: Enum_Four_Plus_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4+1`)
};

/**
* | output |
* | --- |
* | "4+1" |
*
* @param {Enum_Four_Plus_OneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_four_plus_one = /** @type {((inputs?: Enum_Four_Plus_OneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Four_Plus_OneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_four_plus_one(inputs)
	return cs_enum_four_plus_one(inputs)
});